import currencyFormatter from '~/libs/currency-formatter.js';
import getLocale from '~/libs/locale.js';
import { replaceNonBreakingSpace } from './string-num-clean.js';

// a wrapper to use default locale-value for currency if no cookie exists
// or is provided as parameter
function formatAmount(amount = 0, currency, loc) { //eslint-disable-line
	if (!currency) {
		return null;
	}
	const locale = loc || getLocale() || 'en_GB';
	const formatted = currencyFormatter.format(amount, currency, locale);

	return replaceNonBreakingSpace(formatted);
}
export default formatAmount;
